import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import { tokenStore } from "@/auth/token-store";
import { markSignedIn } from "@/auth/session";
import { useSessionStore } from "@/stores/session";
import { LoadingState } from "@/components/feedback/states";

interface CallbackSearch {
  token?: string;
  refresh?: string;
  saml_error?: string;
  oidc_error?: string;
}

export const Route = createFileRoute("/_auth/auth/callback")({
  validateSearch: (s: Record<string, unknown>): CallbackSearch => {
    const str = (v: unknown) => (typeof v === "string" ? v : undefined);
    return {
      token: str(s.token),
      refresh: str(s.refresh),
      saml_error: str(s.saml_error),
      oidc_error: str(s.oidc_error),
    };
  },
  component: CallbackPage,
});

function CallbackPage() {
  const { token, refresh, saml_error, oidc_error } = Route.useSearch();
  const navigate = useNavigate();
  const setUser = useSessionStore((s) => s.setUser);
  const err = saml_error ?? oidc_error;

  useEffect(() => {
    if (token) {
      tokenStore.set(token, refresh);
      markSignedIn();
      setUser(null);
      navigate({ to: "/" });
    }
  }, [token, refresh, navigate, setUser]);

  if (err) {
    return (
      <Stack spacing={2}>
        <Alert severity="error">{decodeURIComponent(err)}</Alert>
        <Button variant="contained" onClick={() => navigate({ to: "/login" })}>
          Back to sign in
        </Button>
      </Stack>
    );
  }
  return <LoadingState label="Completing sign-in…" />;
}
